import styled from 'styled-components'
export const Wrapper = styled.div`
  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 150%;
    color: #212761;
    text-align: center;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: 24px;
    }
  }
  .blue {
    background: ${({ theme }) => theme.colors.secondPrimary};
    border-radius: 5px;
    height: 50px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.white};
    width: 324px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 254px;
      font-size: 13px;
    }
  }
  .center {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      justify-content: center;
      text-align: center;
    }
  }
  .white {
    width: 324px;
    background-color: transparent;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.secondPrimary};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 254px;
      font-size: 13px;
    }
  }
`
